<template>
  <g-page-wrapper>
    <template slot="pageTitle">
      <g-page-title v-if="this.userInfo.auth !== 'AM'" :title="$t('pages_product_used_amount_rank.title')"></g-page-title>
      <g-page-title v-if="this.userInfo.auth === 'AM'" :title="$t('pages_product_used_amount_rank.title_am')"></g-page-title>
    </template>
    <g-contents>
      <div class="-p-5">
        <div class="-tile-container -bg-white -border-radius-1 -overflow-x-hidden -overflow-y-hidden">
          <div class="-wrapper-between">
            <div class="dropDown-wrap custom-select">
              <g-dropdown
                style="padding: 10px;width: 10%"
                id="dashboard-payment-chart-select-month"
                v-model="category"
                @change="changeUsedAmountProducts"
                text-class="-mx-0 -pr-0 -pl-2">
                <g-dropdown-item-wrap class="-bg-white -box-shadow-level-4">
                  <g-dropdown-item value="all" text="" :text="$t('pages_product_used_amount.all')"></g-dropdown-item>
                  <g-dropdown-item value="month" text="" :text="$t('pages_product_used_amount.month')"></g-dropdown-item>
                  <g-dropdown-item value="category" text="" :text="$t('pages_product_used_amount.category')"></g-dropdown-item>
                  <g-dropdown-item value="productName" text="" :text="$t('pages_product_used_amount.product_name')"></g-dropdown-item>
                </g-dropdown-item-wrap>
              </g-dropdown>
            </div>
            <div style="width: 88%;padding: 5px" v-if="category === 'month' && category !== 'all'">
              <div style="float: left;margin-top: 5px">
                <date-picker
                  :lang="lang"
                  type="month"
                  @change="changeUsedAmountProducts"
                  v-model="startMonth">
                </date-picker>
                <date-picker
                  :lang="lang"
                  type="month"
                  @change="changeUsedAmountProducts"
                  v-model="endMonth">
                </date-picker>
              </div>
              <div>
                <g-search-bar
                  no-border
                  @keyup="changeUsedAmountProducts"
                  placeholder="Search anything"
                  v-model="search"
                />
              </div>
            </div>
            <g-search-bar
              v-if="category !== 'month'"
              style="width: 90%"
              no-border
              @keyup="changeUsedAmountProducts"
              placeholder="Search anything"
              v-model="search"
            />
            <g-button
              variant="borderless"
              size="small"
              icon-only
              class="-mr-0 -mt-2"
              @click="onClickDownload">
              <g-icon name="get_app" font-size="20" color="gray-1"/>
            </g-button>
          </div>
          <ag-grid-vue
            style="height: 650px;"
            class="ag-theme-balham"
            row-height="30"
            header-height="30"
            :defaultColDef="this.defaultColDef"
            :columnDefs="columnDefs"
            :gridOptions="gridOptions"
            :rowData="productRankList"
            :modules="modules"
            @row-data-changed="onRowDataChanged"
            @row-clicked="selectBillDetail"
            @grid-ready="onGridReady">
          </ag-grid-vue>
          <g-pagenation
            class="-py-6"
            :page-no="this.paging.pageNo"
            :page-size-list="pageSizeList"
            :page-size="this.paging.size"
            :total-count="this.paging.totalCount"
            @change-page-no="onChangePageNo"
            @change-page-size="onChangePageSize"/>
        </div>
      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/ko'
import {AgGridVue} from 'ag-grid-vue'
import AgGridMixin from '../mixin/AgGrid.mixin'
import {DEFAULT_OPTION_PER_PAGE, DEFAULT_PAGE_SIZE} from "@/constants/constants"
import {mapActions, mapGetters} from "vuex"
import moment from "moment"
import {AUTH_GROUP} from "@/constants/constants"

export default {
  name: 'sales-and-payment',
  componentName: 'SalesAndPayment',
  components: {
    DatePicker,
    AgGridVue
  },
  computed: {
    ...mapGetters('product', ['productRankList', 'productRankPaging', 'productRankSearchParam']),
    ...mapGetters('user', ['userInfo'])
  },
  beforeMount() {
    if( this.productRankSearchParam !== undefined && this.productRankSearchParam.loaded === true) {
      this.category = this.productRankSearchParam.category
      this.search = this.productRankSearchParam.search
      this.paging.size = this.productRankSearchParam.pageSize
      this.startMonth = this.productRankSearchParam.startMonth
      this.endMonth = this.productRankSearchParam.endMonth
      this.size = this.productRankSearchParam.pageSize
      this.paging.pageNo = this.productRankSearchParam.pageNo
    } else {
      let now = new Date()
      this.startMonth = new Date(now.setMonth(now.getMonth() - 1))
      this.endMonth = now
    }
    let now = new Date()
    if(this.$route.query.selectMonth){
      this.search = this.$route.query.selectMonth.replace("/", "-")
      now = new Date(this.$route.query.selectMonth)
    }
    this.changeUsedAmountProducts()
    this.gridOptions = {
      ...this.gridOptions,
      getRowStyle: params => {
        if(this.userInfo.auth !== AUTH_GROUP.AccountManager){
          return {"cursor":"pointer"}
        }
      },
      onGridReady: (params) => {
        this.columnDefs.forEach(item => {
          const column = this.gridOptions.columnApi.getColumn(item.field)
          column.addEventListener('sortChanged', (value) => {
            this.selectCol++
            this.$showSpinner(true)
            const sortVal = column.getSort()
            if('totalAmount' === item.field){
              this.orderCol = item.field + ' * 1'
            }else{
              this.orderCol = item.field
            }
            this.size = DEFAULT_PAGE_SIZE
            if (sortVal === 'desc') {
              this.desc = true
            } else if (sortVal === 'asc') {
              this.desc = false
            } else {
              this.orderCol = null
              this.desc = null
            }
            if(this.selectCol === 1) {
              this.changeUsedAmountProducts()
            }
          })
        })
      }
    }
  },
  mixins: [AgGridMixin()],
  data() {
    return {
      startMonth: '',
      endMonth: '',
      lang: "ko",
      search: '',
      category: 'all',
      pageNo: 1,
      size: DEFAULT_PAGE_SIZE,
      pageSizeList: DEFAULT_OPTION_PER_PAGE,
      orderCol: '',
      selectCol: '',
      clickCount: 0,
      desc: true,
      paging: {
        pageNo: 1,
        size: DEFAULT_PAGE_SIZE,
        totalCount: 0
      },
      defaultColDef: {
        suppressMenu: true,
        sortable: true,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        resizable: true
      },
      columnDefs: [
        {
          field: 'no',
          headerName: 'No.',
          unSortIcon: true,
          comparator: () => false
        },
        {
          field: 'invoiceMonth',
          headerName: this.$t('pages_product_used_amount.month'),
          unSortIcon: true,
          comparator: () => false
        },
        {
          field: 'category',
          headerName: this.$t('pages_product_used_amount.category'),
          unSortIcon: true,
          comparator: () => false
        },
        {
          field: 'productName',
          headerName: this.$t('pages_product_used_amount.product_name'),
          unSortIcon: true,
          comparator: () => false
        },
        {
          field: 'totalAmount',
          headerName: this.$t('pages_product_used_amount.amount'),
          unSortIcon: true,
          cellStyle: {'text-align': "right"},
          comparator: () => false,
          cellRenderer: (params) => {
            return this.$t('pages_product_used_amount.currency') + parseInt(params.value).toLocaleString()
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions('product', ['getProductRankList', 'getCSVDownLoad', 'setProductRankSearchParam']),
    onGridReady(params) {
      this.setGridParams(params)
      this.fitGrid()
    },
    onChangePageNo(pageNo) {
      this.$showSpinner(true)
      this.paging.pageNo = pageNo
      this.changeUsedAmountProducts()
    },
    onChangePageSize(pageSize) {
      this.paging.size = pageSize
      this.paging.pageNo = 1
      this.fitGrid()
      this.changeUsedAmountProducts()
      this.fitGrid()
    },
    onSearch() {
      this.desc = true
      this.changeUsedAmountProducts()
    },
    onClickDownload() {
      let search = this.search === '' ? "" : this.search
      let url = location.origin +'/api/v1/products/product-used-amount-rank-csv?size='+this.paging.totalCount+'&search='+search+'&orderCol='+this.orderCol+'&desc='+this.desc+'&category='+this.category+'&startMonth='+moment(this.startMonth).format('YYYY-MM')+'&endMonth='+moment(this.endMonth).format('YYYY-MM')
      let payLoad = {
        url : url,
        fileName : "products-rank.csv"
        , category: this.category
        , search : this.search
      }
      this.getCSVDownLoad(payLoad)
    },
    saveSearchParam() {
      let params = {
        loaded: true
        , pageNo: this.paging.pageNo
        , search: this.search
        , category: this.category
        , pageSize: this.paging.size
        , startMonth: this.startMonth
        , endMonth: this.endMonth
      }
      this.setProductRankSearchParam(params)
    },
    selectBillDetail(event) {

      if(this.userInfo.auth !== AUTH_GROUP.AccountManager){
        this.$router.push(`/product/info?stratCode=`+event.data.stractNum)
      }
    },
    changeUsedAmountProducts() {
      this.saveSearchParam()
      let payLoad = {}
      payLoad.pageNo      = this.paging.pageNo
      payLoad.size        = this.paging.size
      payLoad.search      = this.search.trim()
      payLoad.orderCol    = this.orderCol
      payLoad.desc        = this.desc
      payLoad.category    = this.category
      payLoad.startMonth  = moment(this.startMonth).format('YYYY-MM')
      payLoad.endMonth    = moment(this.endMonth).format('YYYY-MM')
      this.getProductRankList(payLoad)
    },
    onRowDataChanged () {
      this.fitGrid()
    },
    changeCategory() {
      this.paging.pageNo = 1
      this.onSearch()
    },
  },
  watch: {
    search() {
      clearTimeout(this.debounce)
      this.paging.pageNo = 1
      this.debounce = setTimeout(() => {
        this.gridOptions.columnApi.resetColumnState()
        this.onSearch()
      }, 250)
    },
    productRankPaging() {
      this.paging.pageNo = this.productRankPaging.pageNo
      this.paging.size = this.productRankPaging.size
      this.paging.totalCount = this.productRankPaging.totalCount
      this.fitGrid()
      this.$showSpinner(false)
      this.selectCol = 0
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/product/ProductRankMonth.vue